module.exports = __webpack_public_path__ + "static/media/kpi.60596584.svg";